export { getPrices } from 'next-flight-server-reference-proxy-loader?id=7f86201e7e49a892891b91cba7052da7588c527ef0&name=getPrices!'